import { gql } from '@apollo/client'

export const UPDATE_USER_TABLE_COLUMN_VISIBILITY = gql`
  mutation UpdateUserTableColumnVisibility(
    $tableId: String!
    $hiddenColumns: [String!]!
  ) {
    updateUserTableColumnVisibility(
      tableId: $tableId
      hiddenColumns: $hiddenColumns
    ) {
      tableId
      tenantHiddenColumns
      userHiddenColumns
      effectiveHiddenColumns
    }
  }
`
